import { api } from '../api.js';

// The first-run setup's steps and the one rule for "is this step done". Shared by the
// setup guide itself and the "Finish setting up" prompt, so they never disagree.
export const STEPS = [
  { key: 'domain', short: 'Prove your domain', time: '5 min' },
  { key: 'email', short: 'Your business email', time: '1 min' },
  { key: 'people', short: 'People and sending addresses', time: '3 min' },
  { key: 'website', short: 'Protect your website', time: '5 min' },
  { key: 'phones', short: 'Phone numbers', time: '1 min' },
  { key: 'bank', short: 'Bank details', time: '1 min' },
  { key: 'suppliers', short: 'Suppliers', time: '3 min' },
];

export function setupStatus({ summary, people = [], website, suppliers, user }) {
  if (!summary) return {};
  const domains = summary.domains || [];
  const identifiers = summary.identifiers || [];
  const mine = String(user?.email || '').split('@')[1];
  return {
    domain: domains.some((d) => d.status === 'verified'),
    email: domains.some((d) => d.domain === mine),
    people: people.length > 0 || identifiers.some((i) => i.type === 'email_address'),
    website: !!website?.domains?.some((d) => d.snippet_seen_at),
    phones: identifiers.some((i) => i.type === 'phone'),
    bank: identifiers.some((i) => i.type === 'bank'),
    suppliers: (suppliers?.suppliers || []).length > 0,
  };
}

// Everything setupStatus needs, loaded the same way the guide loads it.
export async function loadSetupData(orgId) {
  const base = `/portal/organisations/${orgId}`;
  const [summary, p, suppliers, website] = await Promise.all([
    api(base), api(`${base}/people`).catch(() => ({ people: [] })),
    api(`${base}/suppliers`).catch(() => ({ suppliers: [], categories: {} })), api(`${base}/website`).catch(() => null),
  ]);
  return { summary, people: p.people || [], suppliers, website };
}
